module.exports = __webpack_public_path__ + "img/bg_c06de76.webp";